import React, { useState } from "react";
import { Catalogo } from "./Catalogo";
import { CatalogoMateriales } from "./CatalogoMateriales";

// Punto de entrada único del tab "Catálogo" para el cliente: agrupa las dos
// ideas por separado (Ambientes = inspiración de trabajos/estilos por
// espacio; Materiales = catálogo técnico de lo que ya carga Andy en Admin →
// Materiales) bajo un mismo selector, en vez de dos tabs sueltos en el
// bottom nav (que ya está lleno).
export const CatalogoCliente = () => {
  const [vista, setVista] = useState("ambientes");

  return (
    <div>
      <div
        className="container pt-4"
        style={{ display: "flex", gap: 8, position: "sticky", top: 0, zIndex: 10, background: "var(--bg-base)", paddingBottom: 10 }}
      >
        {[
          { id: "ambientes", label: "Ambientes" },
          { id: "materiales", label: "Materiales" },
        ].map((op) => (
          <button
            key={op.id}
            onClick={() => setVista(op.id)}
            style={{
              flex: 1, border: "1.5px solid var(--border-subtle)", borderRadius: 12, padding: "10px 14px",
              fontSize: 13.5, fontWeight: 700, cursor: "pointer",
              background: vista === op.id ? "var(--brand-primary)" : "var(--surface-secondary)",
              color: vista === op.id ? "#fff" : "var(--text-primary)",
            }}
          >
            {op.label}
          </button>
        ))}
      </div>
      {vista === "ambientes" ? <Catalogo isAdmin={false} /> : <CatalogoMateriales />}
    </div>
  );
};
